let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("89t7Y")).then(() => parcelRequire('iYTly'));